import React from 'react';
import * as Styles from './style';
import { P } from 'components/reusable-css';
import Heading from 'components/Heading/Heading';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ALL, handleConvert } from 'components/firewall/utils';
import { useQuery } from 'react-query';

const FirewallStep2 = ({ title = '', firewallTemplate = [], white = false }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const { data: fwObjects } = useQuery('/vs/firewall/objects');
  const filterObjectById = (id) => handleConvert(fwObjects?.firewall_object?.find((obj) => obj.id === id)?.label);

  return (
    <Styles.FirewallStep2 white={white}>
      <Heading name={title}>
        <Styles.ListContainers>
          {firewallTemplate?.length <= 0 && (
            <div className="pt-5 pb-5">
              <P>{t('vs/firewall.string86')}</P>
            </div>
          )}
          {isDesktop ? (
            <Box>
              {firewallTemplate?.length > 0 && (
                <Styles.Headers>
                  <Styles.Column>
                    <P>{t('vs/firewall.string20')}</P>
                  </Styles.Column>
                  <Styles.Column>
                    <P>{t('vs/firewall.string22')}</P>
                  </Styles.Column>
                  <Styles.Column>
                    <P>{t('vs/firewall.string67')}</P>
                  </Styles.Column>
                  <Styles.Column>
                    <P>{t('vs/firewall.string24')}</P>
                  </Styles.Column>
                  <Styles.Column>
                    <P>{t('vs/firewall.string25')}</P>
                  </Styles.Column>
                  <Styles.Column>
                    <P>{t('vs/firewall.string23')}</P>
                  </Styles.Column>
                </Styles.Headers>
              )}
              {firewallTemplate.map((rule, index) => (
                <Styles.Card key={index}>
                  <Styles.Column>{rule.order}</Styles.Column>
                  <Styles.Column>
                    <Styles.ActionBadge type={rule.action}>
                      {t(rule.action == 'allow' ? 'vs/firewall.string54' : 'vs/firewall.string55')}
                    </Styles.ActionBadge>
                  </Styles.Column>
                  <Styles.SingleColumn>
                    <P>{rule.protocol == ALL ? t('vs/firewall.string83') : rule.protocol}</P>
                  </Styles.SingleColumn>
                  <Styles.SingleColumn>
                    <P>
                      {rule.src == ALL || rule.src == '0/0'
                        ? t('vs/firewall.string77')
                        : rule.src || filterObjectById(rule.src_object)}
                    </P>
                  </Styles.SingleColumn>
                  <Styles.SingleColumn>
                    <P>
                      {rule.dst_ip == ALL || rule.dst_ip == '0/0'
                        ? t('vs/firewall.string76')
                        : rule.dst_ip || filterObjectById(rule.dst_ip_object)}
                    </P>
                  </Styles.SingleColumn>
                  <Styles.SingleColumn>
                    <P>{rule.dst_service || filterObjectById(rule.dst_service_object)}</P>
                  </Styles.SingleColumn>
                </Styles.Card>
              ))}
            </Box>
          ) : (
            <Box>
              {firewallTemplate.map((rule, index) => (
                <Styles.MobileCard key={index}>
                  <Styles.FlexBetweenColumn>
                    <div>
                      <P className="m-0">{t('vs/firewall.string20')}:</P>
                      <P className="m-0">{rule.order}</P>
                    </div>
                  </Styles.FlexBetweenColumn>
                  <Styles.FlexBetweenColumnBorder>
                    <div>
                      <P className="m-0">{t('vs/firewall.string22')}:</P>
                      <Styles.MobileActionBadge type={rule.action}>
                        {t(rule.action == 'allow' ? 'vs/firewall.string54' : 'vs/firewall.string55')}
                      </Styles.MobileActionBadge>
                    </div>
                    <div>
                      <P className="m-0">{t('vs/firewall.string67')}:</P>
                      <P className="m-0">{rule.protocol}</P>
                    </div>
                    <Styles.SingleColumnMobile>
                      <P>{t('vs/firewall.string23')}:</P>
                      <P>{rule.dst_service || filterObjectById(rule.dst_service_object)}</P>
                    </Styles.SingleColumnMobile>
                  </Styles.FlexBetweenColumnBorder>
                  <Styles.FlexBetweenColumn>
                    <Styles.SingleColumnMobile>
                      <P>{t('vs/firewall.string24')}:</P>
                      <P>
                        {rule.src == ALL || rule.src == '0/0'
                          ? t('vs/firewall.string77')
                          : rule.src || filterObjectById(rule.src_object)}
                      </P>
                    </Styles.SingleColumnMobile>
                    <Styles.SingleColumnMobile>
                      <P>{t('vs/firewall.string25')}:</P>
                      <P>
                        {rule.dst_ip == ALL || rule.dst_ip == '0/0'
                          ? t('vs/firewall.string76')
                          : rule.dst_ip || filterObjectById(rule.dst_ip_object)}
                      </P>
                    </Styles.SingleColumnMobile>
                  </Styles.FlexBetweenColumn>
                </Styles.MobileCard>
              ))}
            </Box>
          )}
        </Styles.ListContainers>
      </Heading>
    </Styles.FirewallStep2>
  );
};

export default FirewallStep2;
